/**
 * best-sellers.js
 *
 * 1. PC sticky: 用 scroll 事件 + getBoundingClientRect 模拟
 *    绕过父容器 overflow:hidden 导致 position:sticky 失效的问题
 *
 * 2. Mobile slider: scroll snap + 圆点同步
 */

(function () {
  'use strict';

  var MOBILE_BP = 750;

  /* ─── 获取固定 header 高度 ─── */
  function getHeaderHeight() {
    var selectors = [
      '#shopify-section-header',
      'header.site-header',
      'header[role="banner"]',
      '.header-wrapper',
      '.site-header',
      'header',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      var rect = el.getBoundingClientRect();
      if (rect.top <= 4 && rect.height > 0) return Math.round(rect.height);
    }
    return 0;
  }

  /* ─── PC STICKY ─── */
  function initSticky(section) {
    var left   = section.querySelector('.best-sellers__left');
    var sticky = section.querySelector('.best-sellers__sticky');
    if (!left || !sticky) return;

    var GAP = 24; // px below header

    function update() {
      if (window.innerWidth < MOBILE_BP) {
        // 手机端重置
        sticky.style.position = '';
        sticky.style.top = '';
        sticky.style.width = '';
        return;
      }

      var headerH   = getHeaderHeight();
      var offsetTop = headerH + GAP;           // 目标：距视口顶部的距离
      var leftRect  = left.getBoundingClientRect();
      var stickyH   = sticky.offsetHeight;
      var sectionRect = section.getBoundingClientRect();

      // 还没滚到触发点 → 正常流
      if (leftRect.top > offsetTop) {
        sticky.style.position = 'relative';
        sticky.style.top = '0';
        sticky.style.width = '';
        return;
      }

      // 滚过底部 → 钉在底部
      var bottomLimit = sectionRect.bottom - stickyH - GAP;
      if (bottomLimit < offsetTop) {
        sticky.style.position = 'relative';
        sticky.style.top = (left.offsetHeight - stickyH) + 'px';
        sticky.style.width = '';
        return;
      }

      // 正在 sticky 区间 → fixed
      sticky.style.position = 'fixed';
      sticky.style.top = offsetTop + 'px';
      sticky.style.width = left.offsetWidth + 'px';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function() { fixSliderWidth(section); });
    window.addEventListener('resize', update);
    update();
  }

  /* ─── MOBILE SLIDER ─── */
  function initSlider(section) {
    var track = section.querySelector('.bs-slider__track');
    var dots  = Array.prototype.slice.call(section.querySelectorAll('.bs-slider__dot'));
    if (!track || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth;
        if (!w) return;
        var index = Math.round(track.scrollLeft / w);
        setActive(index);
      }, 50);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  /* ─── MOBILE SLIDER WIDTH FIX ─── */
  function fixSliderWidth(section) {
    if (window.innerWidth >= MOBILE_BP) return;
    var track = section.querySelector('.bs-slider__track');
    var slides = section.querySelectorAll('.bs-slider__slide');
    var cards = section.querySelectorAll('.bs-slider__card');
    if (!track) return;

    var w = document.documentElement.clientWidth; // 不含滚动条的视口宽度
    var cardW = w - 48;             // 左右各留 24px，确保不超出

    track.style.width = w + 'px';
    slides.forEach(function(slide) {
      slide.style.flex = '0 0 ' + w + 'px';
      slide.style.width = w + 'px';
      slide.style.display = 'flex';
      slide.style.justifyContent = 'center';
      slide.style.alignItems = 'flex-start';
    });
    cards.forEach(function(card) {
      card.style.width = cardW + 'px';
    });
  }

  /* ─── INIT ─── */
  function init() {
    document.querySelectorAll('.best-sellers').forEach(function (section) {
      fixSliderWidth(section);
      initSticky(section);
      initSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.best-sellers')) init();
  });

})();